module.exports = __webpack_public_path__ + "img/04—01—02—Local IP phone credentials.b19b89b3.jpg";